import { ButtonHTMLAttributes } from 'react'

export interface TextButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  overColoredPad?: boolean

  'data-qa'?: string
}
